const designTokens = {
  colors: [
    { name: 'Primary', value: 'var(--color-primary)' },
    { name: 'Primary 400', value: 'var(--color-primary-400)' },
    { name: 'Primary 200', value: 'var(--color-primary-200)' },
    { name: 'Primary 100', value: 'var(--color-primary-100)' },

    { name: 'Secondary', value: 'var(--color-secondary)' },
    { name: 'Secondary 400', value: 'var(--color-secondary-400)' },
    { name: 'Secondary 200', value: 'var(--color-secondary-200)' },
    { name: 'Secondary 100', value: 'var(--color-secondary-100)' },

    { name: 'Tertiary', value: 'var(--color-tertiary)' },
    { name: 'Tertiary 400', value: 'var(--color-tertiary-400)' },
    { name: 'Tertiary 200', value: 'var(--color-tertiary-200)' },
    { name: 'Tertiary 100', value: 'var(--color-tertiary-100)' },

    { name: 'Neutral', value: 'var(--color-neutral)' },
    { name: 'Neutral 400', value: 'var(--color-neutral-400)' },
    { name: 'Neutral 200', value: 'var(--color-neutral-200)' },
    { name: 'Neutral 100', value: 'var(--color-neutral-100)' },

    { name: 'Dark', value: 'var(--color-dark)' },
    { name: 'Dark 400', value: 'var(--color-dark-400)' },
    { name: 'Dark 200', value: 'var(--color-dark-200)' },
    { name: 'Dark 100', value: 'var(--color-dark-100)' },

    { name: 'Alternate', value: 'var(--color-alternate)' },
    { name: 'Alternate 400', value: 'var(--color-alternate-400)' },
    { name: 'Alternate 200', value: 'var(--color-alternate-200)' },
    { name: 'Alternate 100', value: 'var(--color-alternate-100)' },
  ],
  fontFamily: [
    { name: 'Title', value: 'var(--font-title)' },
    { name: 'Heading', value: 'var(--font-heading)' },
    { name: 'Text', value: 'var(--font-base)' },
  ],
  fontSize: false,
  spacing: [
    { name: 'None', value: '0' },
    { name: 'XS', value: 'var(--spacing-xs)' },
    { name: 'Small', value: 'var(--spacing-small)' },
    { name: 'Regular', value: 'var(--spacing-regular)' },
    { name: 'Large', value: 'var(--spacing-large)' },
    { name: 'XL', value: 'var(--spacing-xl)' },
    { name: 'Auto', value: 'auto' },
  ],
  maxWidth: [
    { name: 'Container', value: 'var(--container-default)' },
    { name: 'None', value: 'none' },
  ],
};

export default designTokens;
